export const getElapsedSeconds = (startedAt: number | null) => {
	if (startedAt == null) {
		return 0;
	}

	return Math.max(0, Math.round((Date.now() - startedAt) / 1000));
};
